import React from 'react';
import * as S from './compose-controls.styles';

interface IComposeControlsProps {
    locked: boolean;
    onClose: () => Promise<void> | void;
    onSave: () => Promise<void>;
}
export const ComposeControls: React.FunctionComponent<IComposeControlsProps> = (
    props: IComposeControlsProps,
): React.ReactElement => {
    const { locked, onClose, onSave } = props;

    const cancel = async (): Promise<void> => {
        onClose();
    };
    const save = async (): Promise<void> => {
        onSave();
    };

    return (
        <S.Controls>
            <S.UnderButton variant="primary" onClick={save} disabled={locked}>
                Send
            </S.UnderButton>
            <S.UnderButton variant="outlined" onClick={cancel} disabled={locked}>
                Cancel
            </S.UnderButton>
        </S.Controls>
    );
};
